export default function hexToRGBA(hex: string, alpha = 1) {
  // Remove the hash at the start if it's there
  hex = hex.replace('#', '');
  // Parse the r, g, b values
  let r = parseInt(
    hex.length === 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2),
    16,
  );
  let g = parseInt(
    hex.length === 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4),
    16,
  );
  let b = parseInt(
    hex.length === 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6),
    16,
  );
  // Return the RGBA color
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
